<script setup>
import { computed, ref } from 'vue';
import Icon from 'next/icon/Icon.vue';
import { useSnakeCase } from 'dashboard/composables/useTransformKeys';
import { useMessageContext } from '../provider.js';

import GalleryView from 'dashboard/components/widgets/conversation/components/GalleryView.vue';

const props = defineProps({
  attachment: {
    type: Object,
    required: true,
  },
  // BonBoZ: mot anh di mot minh thi giu dung khung hinh that cua no; nhieu anh
  // thi cat vuong de xep luoi cho deu. Xem AttachmentChips.vue.
  single: {
    type: Boolean,
    default: false,
  },
  // So anh con lai khong ve ra; >0 thi o nay deo them lop "+N".
  remaining: {
    type: Number,
    default: 0,
  },
});

const hasError = ref(false);
const isLoaded = ref(false);
const showGallery = ref(false);

const remainingLabel = computed(() => `+${props.remaining}`);

const { filteredCurrentChatAttachments } = useMessageContext();

// Ti le that cua anh, dung lam cho truoc khi anh ve xong. Khong co thi lay 4:3
// — mot khung tam thoi sai ti le van hon mot cu nhay khi anh tai xong.
const aspectRatio = computed(() => {
  const { width, height } = props.attachment;
  return width && height ? `${width} / ${height}` : '4 / 3';
});

const handleError = () => {
  hasError.value = true;
};
</script>

<template>
  <!-- BonBoZ: o anh trong luoi.
       Ban cu la mot o vuong 72px cung nhac cho MOI truong hop — mot anh gui
       kem loi nhan cung bi thu ve con tem, ma anh truoc/sau cua khach thi cat
       vuong la mat sach phan can so sanh. Gio: di mot minh thi giu ti le that
       va no den het be ngang bong bong, di theo bo thi moi cat vuong.
       Bo `rounded-xl` o tung o: bo goc bo mot lan o vien ngoai cua luoi
       (AttachmentChips) nen ca bo anh doc ra thanh MOT khoi, thay vi mot dam o
       vuong roi rac. -->
  <div
    class="overflow-hidden relative cursor-pointer group bg-n-alpha-1"
    :class="single ? 'w-full' : 'w-full aspect-square'"
    :style="single ? { aspectRatio } : null"
    @click="showGallery = true"
  >
    <div
      v-if="hasError"
      class="flex flex-col gap-1 justify-center items-center text-xs text-center size-full text-n-slate-11"
    >
      <Icon icon="i-lucide-circle-off" class="text-n-slate-11" />
      {{ $t('COMPONENTS.MEDIA.LOADING_FAILED') }}
    </div>
    <template v-else>
      <img
        class="object-cover w-full h-full transition-opacity duration-200 skip-context-menu"
        :class="isLoaded ? 'opacity-100' : 'opacity-0'"
        :src="attachment.dataUrl"
        loading="lazy"
        decoding="async"
        @load="isLoaded = true"
        @error="handleError"
      />
      <!-- Vet sang chay ngang cho anh ve — bao "dang tai", khong phai "hong". -->
      <div
        v-if="!isLoaded"
        class="absolute inset-0 animate-pulse bg-n-alpha-2"
      />
      <!-- Nen toi rat nhat khi re chuot: cho biet o nay bam duoc ma khong lam
           sai mau anh. -->
      <div
        class="absolute inset-0 transition-colors duration-150 bg-n-slate-12/0 group-hover:bg-n-slate-12/10"
      />
      <div
        v-if="remaining > 0"
        class="flex absolute inset-0 justify-center items-center text-xl font-semibold text-white bg-n-slate-12/60"
      >
        {{ remainingLabel }}
      </div>
    </template>
  </div>
  <GalleryView
    v-if="showGallery"
    v-model:show="showGallery"
    :attachment="useSnakeCase(attachment)"
    :all-attachments="filteredCurrentChatAttachments"
    @error="handleError"
    @close="() => (showGallery = false)"
  />
</template>
